import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { formatDateTimeLatam } from '../lib/dates';

interface Inscription {
  event_title?: string;
  course_title?: string;
  name?: string;
  email?: string;
  phone?: string;
  created_at?: string;
}

export default function InscriptionsPage() {
  const [items, setItems] = useState<Inscription[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const data = await api.get<Inscription[]>('/admin/inscriptions');
        if (alive) setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        if (alive) setError(err instanceof ApiError ? err.message : 'No se pudieron cargar las inscripciones');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <>
      <h1 className="page-title">Inscripciones ({items.length})</h1>
      {loading ? <p className="muted">Cargando…</p> :
       error ? <div className="alert alert-error">{error}</div> :
       items.length === 0 ? <div className="empty">Sin inscripciones aún</div> :
        <div className="card">
          {items.map((ins, i) => (
            <div key={i} className="list-item">
              <div className="list-item-title">
                <div style={{ fontWeight: 600 }}>
                  {ins.event_title || ins.course_title || 'Sin título'}
                </div>
                <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>
                  {ins.name} · {ins.email}{ins.phone ? ` · ${ins.phone}` : ''}
                </div>
              </div>
              <div className="list-item-meta">
                {formatDateTimeLatam(ins.created_at)}
              </div>
            </div>
          ))}
        </div>
      }
    </>
  );
}
